import { IndexRouteObject, NonIndexRouteObject } from 'react-router';

import { HomeRoutes } from '../../../../../RouteConstants';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { RouteErrorPage } from '@components/ErrorBoundary';

export const HomeLayoutRoutes: (IndexRouteObject | NonIndexRouteObject)[] = [
  {
    id: 'welcome',
    index: true,
    hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
    async lazy() {
      const HomeLayoutNonLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutNonLoginRoutes')
      ).default;

      const Welcome = (await import('../../../../../../Modules/Home/Welcome/Welcome')).default;

      return {
        errorElement: <RouteErrorPage />,
        element: <HomeLayoutNonLoginRoutes content={<Welcome />} />,
      };
    },
  },
  {
    path: HomeRoutes.terms,
    hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
    async lazy() {
      const HomeLayoutNonLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutNonLoginRoutes')
      ).default;

      const TermsAndConditions = (
        await import('../../../../../../Modules/Home/TermsAndConditions/TermsAndConditions')
      ).default;

      return {
        errorElement: <RouteErrorPage />,
        element: <HomeLayoutNonLoginRoutes content={<TermsAndConditions />} />,
      };
    },
  },
  {
    path: HomeRoutes.support,
    hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
    async lazy() {
      const HomeLayoutNonLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutNonLoginRoutes')
      ).default;
      const Support = (await import('../../../../../../Modules/Home/Support/Support')).default;

      return {
        errorElement: <RouteErrorPage />,
        element: <HomeLayoutNonLoginRoutes content={<Support />} />,
      };
    },
  },
];
